export default __webpack_public_path__ + "static/media/mTop_1_c3.6a3bbc76.jpeg";